import { Timestamp } from "firebase/firestore";
import { z } from "zod";

/**
 * The cap firestore.rules enforces on `body` (isValidPersonNote). The textarea
 * applies it as `maxLength`, which counts UTF-16 units and so never lets
 * through more characters than the rule counts.
 */
export const PERSON_NOTE_MAX_LENGTH = 2000;

/**
 * `users/{uid}/person_notes/{eventId}__{attendeeId}`. The rules pin the id to
 * the two fields, so this is the only spelling that can be written.
 */
export function personNoteId(eventId: string, attendeeId: string): string {
  return `${eventId}__${attendeeId}`;
}

const timestamp = z.instanceof(Timestamp).optional();

export const personNoteSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  attendeeId: z.string(),
  /** The name the author saw when writing. Shown once the person leaves the directory. */
  personName: z.string(),
  eventTitle: z.string().optional(),
  eventSlug: z.string().optional(),
  body: z.string(),
  createdAt: timestamp,
  updatedAt: timestamp,
});
export type PersonNote = z.infer<typeof personNoteSchema>;

/** What the author's membership contributes to a note: the event snapshot. */
export interface NoteEventSnapshot {
  eventTitle?: string;
  eventSlug?: string;
}
